import type { ComponentChildren } from "preact";

interface CardProps {
  title: string;
  variant?: "default" | "danger";
  children: ComponentChildren;
}

export function Card({ title, variant = "default", children }: CardProps) {
  const cls = ["card", variant !== "default" ? `card--${variant}` : ""]
    .filter(Boolean)
    .join(" ");
  return (
    <article class={cls}>
      <h2 class="card-title">{title}</h2>
      {children}
    </article>
  );
}
